import { render, staticRenderFns } from "./PreferencesAdminFuncionalities.vue?vue&type=template&id=52b3cbb0"
import script from "./PreferencesAdminFuncionalities.vue?vue&type=script&lang=js"
export * from "./PreferencesAdminFuncionalities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports